import { useFormContext } from 'react-hook-form';
import ErrorMessage from 'components/ui/ErrorMessage/ErrorMessage';

const BookingAgreement = ({ insuranceType, userType, booking }) => {
  const { register, errors } = useFormContext();
  const { insurance_policy_url } = booking;

  const textColor = () => {
    switch (userType) {
      case 'captain':
        return 'u-textCaptains';
      case 'renter':
        return 'u-textPrimary';
      case 'owner':
        return 'u-textOwners';
      default:
        return 'u-textPrimary';
    }
  };

  const checkBoxColor = () => {
    switch (userType) {
      case 'captain':
        return 'Checkbox--captains';
      case 'renter':
        return '';
      case 'owner':
        return 'Checkbox--owners';
      default:
        return '';
    }
  };

  return (
    <div className="u-pv1 approve-agreements u-fsSmMd">
      {insuranceType === 'p2p' && (
        <div>
          <div className="u-mb1 u-sm-mb1">
            <label htmlFor="policy" className="u-flex u-flexAlignItemsStart">
              <input
                id="policy"
                name="policy"
                data-testid="insurance-policy-checkbox"
                className={`Checkbox u-mr1 ${checkBoxColor()}`}
                type="checkbox"
                ref={register({ validate: (value) => !!value })}
              />
              <span>
                I have read, understand, and agree to the &nbsp;
                <a className={`${textColor()}`} href={insurance_policy_url} target="_blank" rel="noreferrer">
                  Insurance Policy
                </a>
              </span>
            </label>
            <ErrorMessage
              error={errors.policy}
              message="You must read and accept the insurance policy to proceed with your booking."
            />
          </div>
        </div>
      )}

      <div className="u-mb1 u-sm-mb1 ">
        <label htmlFor="agree_to_terms" className="u-flex u-flexAlignItemsStart">
          <input
            type="checkbox"
            name="agree_to_terms"
            id="agree_to_terms"
            data-testid="terms-checkbox"
            className={`Checkbox u-mr1 ${checkBoxColor()}`}
            ref={register({ validate: (value) => !!value })}
          />
          <span>
            I have read, understand, and agree to the &nbsp;
            <a target="_blank" href="/terms" className={`${textColor()}`}>
              Terms of Service
            </a>
            <span className="u-phz05"> & </span>
            <a target="_blank" className={`${textColor()}`} href="/legal/time_charter_party_agreement">
              Charter Party Agreement
            </a>
          </span>
        </label>
        <ErrorMessage
          error={errors.agree_to_terms}
          message="You must read and accept the Terms of Service & Charter Agreement to proceed with your booking"
        />
      </div>

      <div className="u-mb05" />

      <div className="u-mb2 u-sm-mb2 ">
        <label htmlFor="agree_uscg" className="u-flex u-flexAlignItemsStart">
          <input
            name="agree_uscg"
            id="agree_uscg"
            type="checkbox"
            data-testid="uscg-policy-checkbox"
            className={`Checkbox u-mr1 ${checkBoxColor()}`}
            data-parsley-multiple="agree_uscg"
            ref={register({ validate: (value) => !!value })}
          />
          <div>
            <span>I have read, understand, and agree to the </span>
            <a href="/resources/PaxForHire.pdf" target="_blank" className={`${textColor()}`}>
              USCG regulations
            </a>
            <span> for this {booking.package_type} charter</span>
          </div>
        </label>
        <ErrorMessage
          error={errors.agree_uscg}
          message="You must read and accept the USCG regulations to proceed with your booking."
        />
      </div>
    </div>
  );
};

export default BookingAgreement;
